import { render } from "./SidebarNavigation.vue?vue&type=template&id=3eefc56e&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=3eefc56e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eefc56e"]])

export default __exports__